// TODO(ui-api): spec gap (item 9) — env_health response models
import { useServicesQuery } from '@/services/api';
import { WORKSPACE_HEALTH_CHECK_INTERVAL } from '../constants';

/**
 * Lightweight off-page health check.
 *
 * Polls GET /v1/environments/:workspaceId/health/check at 60s when enabled.
 * Should only be enabled when the user is NOT on the workspace-health dashboard
 * (i.e. when `active` is false in useEnvHealth).
 */
export function useEnvHealthCheck(workspaceId: number, enabled: boolean) {
  return useServicesQuery(
    'getEnvHealthCheck',
    { params: { environment_id: workspaceId } },
    {
      refetchInterval: WORKSPACE_HEALTH_CHECK_INTERVAL,
      enabled: enabled && workspaceId > 0,
      refetchOnWindowFocus: 'always',
      refetchOnMount: 'always',
    },
  );
}
